/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol extends models.ServiceAccountCredentialsBaseForAzureSecurityGraph {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol>): ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol(), model);
        ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol>): ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.newInstance(<ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureSecurityGraph.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureSecurityGraphBasicAuthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

}
